/** Toasts, labels e mensagens residuais — PT / EN / ES */
export const miscTranslations = {
  pt: {
    'public_orders.toast.cep_not_found': 'CEP não encontrado',
    'public_orders.toast.max_addons': 'Limite máximo de {max} adicional(is) para {category}',
    'public_orders.toast.addons_min_in_item':
      'No item "{item}", é necessário escolher pelo menos {min} item(ns) de "{category}"',

    'orders.toast.max_flavors': 'Máximo de {max} sabor(es) para este tipo',
    'orders.toast.max_addons': 'Limite máximo de {max} adicional(is) para {category}',
    'orders.toast.invalid_deadline_range':
      'Por favor, informe valores válidos (mínimo deve ser menor ou igual ao máximo)',
    'orders.toast.save_deadline_error': 'Erro ao salvar prazo',
    'orders.toast.delete_deadline_success': 'Prazo excluído com sucesso',
    'orders.toast.delete_deadline_error': 'Erro ao excluir prazo',
    'orders.toast.update_deadline_success': 'Prazo de entrega atualizado com sucesso',
    'orders.toast.update_deadline_error': 'Erro ao atualizar prazo selecionado',
    'orders.toast.select_product_size': 'Por favor, selecione o tamanho/tipo do produto',
    'orders.toast.select_flavors_count': 'Por favor, selecione {count} sabor(es) para este tipo',
    'orders.toast.addons_min_for_product':
      'É necessário escolher pelo menos {min} item(ns) de "{category}" para este produto',
    'orders.toast.print_request_failed':
      'Erro ao processar solicitação de impressão após múltiplas tentativas',
    'orders.toast.print_order_failed': 'Não foi possível imprimir o pedido #{order}.',

    'internal_order.toast.item_updated': 'Item atualizado no carrinho!',
    'internal_order.toast.item_added': 'Produto adicionado ao carrinho!',
    'internal_order.toast.max_flavors': 'Máximo de {max} sabor(es) para este tipo',
    'internal_order.toast.max_addons': 'Limite máximo de {max} adicional(is) para {category}',
    'internal_order.toast.order_parsed_review': 'Pedido interpretado — revise e finalize no checkout',
    'internal_order.toast.customer_data_applied': 'Dados do cliente aplicados ao pedido',
    'internal_order.toast.ifood_applied_review':
      'Pedido iFood aplicado — revise e finalize no checkout',
    'internal_order.toast.no_ai_items_suggestion': 'Nenhuma sugestão de itens para aplicar ao carrinho.',
    'internal_order.toast.no_valid_ai_items': 'Nenhum item válido encontrado na sugestão da IA.',
    'internal_order.toast.ai_items_added':
      'Itens sugeridos pela IA foram adicionados ao carrinho. Revise valores e taxas normalmente.',
    'internal_order.toast.order_parsed_review_menu':
      'Pedido interpretado — revise cardápio, carrinho e finalize',
    'internal_order.toast.customer_data_select_products':
      'Dados do cliente aplicados — escolha os produtos no cardápio',
    'internal_order.toast.question_sent': 'Pergunta enviada — aguardando resposta do cliente',

    'company.toast.image_upload_success': 'Imagem enviada com sucesso.',
    'company.toast.image_upload_error': 'Erro ao fazer upload da imagem.',
    'company.toast.logo_saved': 'Logotipo salvo com sucesso.',
    'company.toast.logo_save_error': 'Erro ao salvar logotipo.',
    'company.toast.logo_removed': 'Logotipo removido com sucesso.',
    'company.toast.logo_remove_error': 'Erro ao remover logotipo.',
    'company.toast.logo_process_error': 'Erro ao processar logomarca.',
    'company.toast.save_generic_error': 'Erro ao salvar: {error}',
    'company.toast.move_bairro_failed_refresh':
      'Não foi possível mover o bairro. Atualize a página e tente novamente.',
    'company.toast.move_bairro_name_required':
      'Preencha o nome do bairro antes de movê-lo para outra taxa.',
    'company.toast.move_bairro_already_exists': 'Este bairro já existe nesta taxa.',
    'company.toast.move_bairro_failed': 'Não foi possível mover o bairro.',
    'company.toast.fee_added_success': 'Taxa de R$ {amount} adicionada com sucesso!',
    'company.toast.menu_category_created': 'Categoria "{name}" criada com sucesso!',

    'menu_display.loading': 'Carregando cardápio...',
    'menu_display.no_products': 'Nenhum produto encontrado no cardápio',
    'menu_display.title.delete_image': 'Excluir imagem',
    'menu_display.title.delete_product': 'Excluir produto',
    'menu_display.title.edit_category': 'Editar categoria e tipos de preço',
    'menu_display.title.delete_category': 'Excluir categoria e todos os produtos',
    'menu_display.zero_price.item': 'Este item está com preço zero. Ele pode continuar ativo.',
    'menu_display.zero_price.category': 'Há itens com preço zero nesta categoria.',
    'menu_display.zero_price.ignore_item': 'Ignorar este item',
    'menu_display.zero_price.ignore_category': 'Ignorar a categoria',
    'menu_display.toast.image_upload_success': 'Imagem enviada com sucesso.',
    'menu_display.toast.image_upload_error': 'Erro ao enviar imagem: {error}',
    'menu_display.toast.image_delete_success': 'Imagem excluída com sucesso.',
    'menu_display.toast.image_delete_error': 'Erro ao excluir imagem: {error}',

    'employees.toast.password_already_set':
      'Este colaborador já criou a senha — peça para fazer login.',
    'employees.toast.invite_link_generate_failed': 'Não foi possível gerar o link de convite.',
    'employees.toast.invite_link_copied': 'Link de convite copiado para {name}.',
    'employees.toast.invite_link_copy_failed': 'Não foi possível copiar o link. Tente novamente.',
    'employees.toast.phone_required_for_invite':
      'Cadastre um telefone válido antes de enviar o convite.',
    'employees.toast.invite_generate_failed': 'Não foi possível gerar o convite.',
    'employees.toast.invite_whatsapp_sent':
      'Convite enviado por WhatsApp para {name} (válido por 30 min).',
    'employees.toast.invite_whatsapp_send_failed':
      'Não foi possível enviar o convite por WhatsApp.',

    'clients.toast.cep_not_found': 'CEP não encontrado.',
    'clients.toast.cep_fetch_error': 'Erro ao buscar CEP. Tente novamente.',
    'clients.toast.name_required': 'Informe o nome do cliente.',
    'clients.toast.phone_invalid': 'Informe um telefone válido (mínimo 10 dígitos).',
    'clients.toast.save_error': 'Erro ao salvar cliente.',
    'clients.toast.new_value_required': 'Informe o novo valor.',
    'clients.toast.no_valid_client_selected':
      'Nenhum cliente selecionado com ID válido para atualizar.',
    'clients.toast.bulk_update_success': '{count} cliente(s) atualizado(s).',
    'clients.toast.bulk_update_partial_fail': '{count} registro(s) não puderam ser atualizados.',
    'clients.toast.bulk_update_error': 'Erro na atualização em massa.',
    'clients.selected_count': '{count} selecionado(s)',

    'order_confirmation.toast.pix_key_copied': 'Chave PIX copiada!',
    'order_confirmation.toast.copy_failed':
      'Não foi possível copiar. Selecione e copie manualmente.',
    'order_confirmation.toast.pix_data_copied': 'Dados PIX copiados para compartilhar!',
    'order_confirmation.toast.share_failed':
      'Não foi possível compartilhar. Tente copiar a chave.',

    'order_confirmation.title': 'Pedido Confirmado!',
    'order_confirmation.thanks': 'Obrigado pelo seu pedido!',
    'order_confirmation.pix_payment': 'Pagamento via PIX',
    'order_confirmation.pix_instructions_with_key':
      'Confira os dados abaixo, copie a chave ou compartilhe tudo no app do seu banco.',
    'order_confirmation.pix_instructions_no_key':
      'Seu pedido foi registrado com PIX. Os dados da loja não estão disponíveis nesta tela — peça pelo WhatsApp ou no balcão.',
    'order_confirmation.holder': 'Titular:',
    'order_confirmation.bank': 'Banco:',
    'order_confirmation.type': 'Tipo:',
    'order_confirmation.pix_key': 'Chave PIX',
    'order_confirmation.copy_pix_aria': 'Copiar chave PIX',
    'order_confirmation.share_pix': 'Compartilhar dados PIX',
    'order_confirmation.shared': 'Compartilhado!',
    'order_confirmation.share_title': 'Dados PIX',
    'order_confirmation.preparing_message':
      'Estamos preparando seu pedido com muito carinho e ele estará pronto em breve.',
    'order_confirmation.preparing_badge': 'Seu pedido está sendo preparado',
    'order_confirmation.track_order': 'Rastrear Pedido',
    'order_confirmation.new_order': 'Fazer Novo Pedido',
    'order_confirmation.footer_hint': 'Você pode fazer um novo pedido a qualquer momento',

    'entregas.status.in_progress': 'Em andamento',
    'entregas.status.done': 'Concluída',
    'entregas.status.cancelled': 'Cancelada',
    'entregas.status.pending': 'Aguardando saída',
    'entregas.customer_fallback': 'Cliente',
    'entregas.stop.delivered': 'Entregue',
    'entregas.stop.pending': 'Pendente',
    'entregas.stop.order': 'Pedido',
    'entregas.stop.dispatch': 'Despacho',
    'entregas.stop.delivery': 'Entrega',
    'entregas.stop.order_to_dispatch': 'Pedido → despacho:',
    'entregas.stop.dispatch_to_delivery': 'Despacho → entrega:',
    'entregas.route.departure': 'Saída {index}',
    'entregas.route.deliveries_count': '{count} entrega(s)',
    'entregas.route.dispatch_at': 'Despacho {time}',
    'entregas.route.started_at': ' · Saída {time}',
    'entregas.route.finished_at': ' · Fim {time}',
    'entregas.duration_min': '{min} min',
    'entregas.duration_h': '{h}h',
    'entregas.duration_h_min': '{h}h {m}min',
    'entregas.date_picker_title': 'Dia operacional (mesma regra do caixa)',
    'entregas.date_prev': 'Dia mais recente',
    'entregas.date_next': 'Dia mais antigo',
    'entregas.mode_work': 'Modo trabalho',
    'entregas.mode_working': 'Trabalhando',
    'entregas.back_to_today': 'Voltar ao dia atual',
    'entregas.avg_min_prefix': '~{min} min',
    'entregas.mode_report': 'Relatório',
    'entregas.refresh': 'Atualizar',
    'entregas.today_suffix': ' · hoje',
    'entregas.hint_work_mode': ' · dia operacional atual (janela do caixa +2h após fechar)',
    'entregas.hint_history': ' · histórico pessoal de entregas',
    'entregas.summary.departures': 'Saída(s)',
    'entregas.summary.deliveries': 'Entrega(s)',
    'entregas.summary.completed': 'Concluída(s)',
    'entregas.summary.avg_dispatch_delivery': 'Média despacho → entrega',
    'entregas.summary.fees': 'Taxas do dia',
    'entregas.summary.daily': 'Diária',
    'entregas.summary.fees_total': 'Taxas + diária',
    'entregas.page.title': 'Minhas entregas',
    'entregas.page.subtitle_active': 'Use as rotas abaixo para sair e dar baixa nas entregas',
    'entregas.page.subtitle_done_today': 'Saídas de hoje concluídas — veja o resumo abaixo',
    'entregas.page.subtitle_waiting': 'Leia o QR do cupom para juntar as entregas',
    'entregas.page.subtitle_report': 'Relatório de {date}',
    'entregas.empty.no_routes': 'Nenhuma rota atribuída no momento.',
    'entregas.empty.no_deliveries_day': 'Nenhuma entrega registrada em {date}.',
    'entregas.empty.hint_work': 'Leia o QR do cupom de despacho no seu usuário. Junte várias comandas e depois inicie a saída na ordem que quiser.',
    'entregas.empty.hint_history': 'Selecione outro dia nos atalhos acima ou volte ao dia atual.',
    'entregas.map_unavailable': 'Mapa embutido indisponível — use a lista e abra cada endereço no Google Maps.',
    'entregas.open_maps': 'Abrir',
    'entregas.open_google_maps': 'Abrir no Google Maps',
    'entregas.delivery_progress': 'Entrega {current} de {total}',
    'entregas.start_departure': 'Iniciar saída',
    'entregas.confirm_delivery': 'Confirmar entrega',
    'entregas.confirm_ifood': 'Confirmar + código iFood',
    'entregas.send_ifood_only': 'Só enviar código à loja',
    'entregas.upcoming': 'Próximas entregas',
    'entregas.departure_running': ' · rolando',
    'entregas.completed_today': 'Saídas concluídas hoje',

    'contract_plan.toast.invalid_cnpj':
      'Se informar CNPJ, use 14 dígitos válidos ou deixe em branco.',
    'contract_pix.toast.nothing_to_copy': 'Nada para copiar ({label}).',
    'contract_pix.toast.copied': '{label} copiado.',
    'contract_pix.toast.copy_failed':
      'Não foi possível copiar. Selecione o texto manualmente.',

    'entregas.toast.load_routes_error': 'Erro ao carregar rotas',
    'entregas.toast.route_started': 'Rota iniciada. Boa entrega!',
    'entregas.toast.route_completed': 'Rota concluída!',
    'entregas.toast.start_route_error': 'Erro ao iniciar rota',
    'entregas.toast.delivery_confirmed': 'Entrega confirmada!',
    'entregas.toast.delivery_ifood_sent': 'Entrega e código iFood enviados!',
    'entregas.toast.confirm_error': 'Erro ao confirmar',
    'entregas.toast.code_sent': 'Código enviado para a loja',
    'entregas.toast.send_code_error': 'Erro ao enviar código',
    'entregas.bag.reorder_hint': '{count} entrega(s) — arraste para definir a 1ª, 2ª…',
    'entregas.pay.paid': 'Já pago — não cobrar',
    'entregas.pay.charge': 'Cobrar na entrega',
    'entregas.pay.charge_amount': 'Cobrar {amount}',
    'entregas.toast.reorder_error': 'Não foi possível salvar a ordem',
    'despacho.title': 'Puxar comanda',
    'despacho.missing_token': 'QR inválido. Peça um cupom de despacho novo.',
    'despacho.need_courier': 'Entre com o usuário do motoboy para puxar esta comanda.',
    'despacho.load_error': 'Não foi possível ler este QR.',
    'despacho.claim': 'Pegar esta entrega',
    'despacho.already_mine': 'Esta comanda já está com você.',
    'despacho.open_app': 'Abrir minhas entregas',
    'despacho.transfer_title': 'Trocar motoboy?',
    'despacho.transfer_msg': 'Esta entrega está com {name}. Quer puxar para você?',
    'despacho.transfer_confirm': 'Sim, puxar para mim',
    'despacho.claimed': 'Comanda na sua sacola.',
    'despacho.scan_next': 'Leia o próximo QR para juntar mais entregas, ou abra a rota para definir a ordem e sair.',
    'despacho.go_bag': 'Definir ordem e sair',
    'despacho.bag_count': '{count} entrega(s) na sacola',
    'despacho.neighborhood': 'Bairro',
    'despacho.payment': 'Pagamento',

    'dev.toast.invalid_cpf': 'CPF inválido. Informe 11 dígitos ou deixe em branco.',
    'dev.toast.invalid_cpf_fix': 'CPF inválido. Corrija o número ou deixe em branco.',
    'dev.toast.name_required': 'Informe o nome completo.',
    'dev.toast.phone_required_whatsapp':
      'Informe o telefone com DDD para enviar o convite por WhatsApp.',
    'dev.toast.registration_sent': 'Cadastro de "{name}" enviado.',
    'dev.toast.registered_whatsapp':
      '"{name}" cadastrado(a). Convite enviado por WhatsApp (30 min).',
    'dev.toast.registered_success': '"{name}" cadastrado(a) com sucesso.',
    'dev.toast.invalid_collaborator_id':
      'CPF ou id do colaborador inválido para salvar permissões.',
    'dev.toast.permissions_updated': 'Permissões atualizadas com sucesso. {hint}',
  },
  en: {
    'public_orders.toast.cep_not_found': 'ZIP code not found',
    'public_orders.toast.max_addons': 'Maximum of {max} add-on(s) for {category}',
    'public_orders.toast.addons_min_in_item':
      'In item "{item}", you must choose at least {min} item(s) from "{category}"',

    'orders.toast.max_flavors': 'Maximum of {max} flavor(s) for this type',
    'orders.toast.max_addons': 'Maximum of {max} add-on(s) for {category}',
    'orders.toast.invalid_deadline_range':
      'Please enter valid values (minimum must be less than or equal to maximum)',
    'orders.toast.save_deadline_error': 'Error saving deadline',
    'orders.toast.delete_deadline_success': 'Deadline deleted successfully',
    'orders.toast.delete_deadline_error': 'Error deleting deadline',
    'orders.toast.update_deadline_success': 'Delivery deadline updated successfully',
    'orders.toast.update_deadline_error': 'Error updating selected deadline',
    'orders.toast.select_product_size': 'Please select the product size/type',
    'orders.toast.select_flavors_count': 'Please select {count} flavor(s) for this type',
    'orders.toast.addons_min_for_product':
      'You must choose at least {min} item(s) from "{category}" for this product',
    'orders.toast.print_request_failed':
      'Error processing print request after multiple attempts',
    'orders.toast.print_order_failed': 'Could not print order #{order}.',

    'internal_order.toast.item_updated': 'Item updated in cart!',
    'internal_order.toast.item_added': 'Product added to cart!',
    'internal_order.toast.max_flavors': 'Maximum of {max} flavor(s) for this type',
    'internal_order.toast.max_addons': 'Maximum of {max} add-on(s) for {category}',
    'internal_order.toast.order_parsed_review': 'Order interpreted — review and checkout',
    'internal_order.toast.customer_data_applied': 'Customer data applied to order',
    'internal_order.toast.ifood_applied_review': 'iFood order applied — review and checkout',
    'internal_order.toast.no_ai_items_suggestion': 'No item suggestions to apply to cart.',
    'internal_order.toast.no_valid_ai_items': 'No valid items found in AI suggestion.',
    'internal_order.toast.ai_items_added':
      'AI-suggested items added to cart. Review prices and fees as usual.',
    'internal_order.toast.order_parsed_review_menu':
      'Order interpreted — review menu, cart and checkout',
    'internal_order.toast.customer_data_select_products':
      'Customer data applied — pick products from the menu',
    'internal_order.toast.question_sent': 'Question sent — waiting for customer reply',

    'company.toast.image_upload_success': 'Image uploaded successfully.',
    'company.toast.image_upload_error': 'Error uploading image.',
    'company.toast.logo_saved': 'Logo saved successfully.',
    'company.toast.logo_save_error': 'Error saving logo.',
    'company.toast.logo_removed': 'Logo removed successfully.',
    'company.toast.logo_remove_error': 'Error removing logo.',
    'company.toast.logo_process_error': 'Error processing logo.',
    'company.toast.save_generic_error': 'Error saving: {error}',
    'company.toast.move_bairro_failed_refresh':
      'Could not move neighborhood. Refresh the page and try again.',
    'company.toast.move_bairro_name_required':
      'Fill in the neighborhood name before moving it to another fee.',
    'company.toast.move_bairro_already_exists': 'This neighborhood already exists in this fee.',
    'company.toast.move_bairro_failed': 'Could not move neighborhood.',
    'company.toast.fee_added_success': 'Fee of ${amount} added successfully!',
    'company.toast.menu_category_created': 'Category "{name}" created successfully!',

    'menu_display.loading': 'Loading menu...',
    'menu_display.no_products': 'No products found in menu',
    'menu_display.title.delete_image': 'Delete image',
    'menu_display.title.delete_product': 'Delete product',
    'menu_display.title.edit_category': 'Edit category and price types',
    'menu_display.title.delete_category': 'Delete category and all products',
    'menu_display.zero_price.item': 'This item has a zero price. It can stay active.',
    'menu_display.zero_price.category': 'This category has items priced at zero.',
    'menu_display.zero_price.ignore_item': 'Ignore this item',
    'menu_display.zero_price.ignore_category': 'Ignore the category',
    'menu_display.toast.image_upload_success': 'Image uploaded successfully.',
    'menu_display.toast.image_upload_error': 'Error uploading image: {error}',
    'menu_display.toast.image_delete_success': 'Image deleted successfully.',
    'menu_display.toast.image_delete_error': 'Error deleting image: {error}',

    'employees.toast.password_already_set':
      'This employee already set a password — ask them to log in.',
    'employees.toast.invite_link_generate_failed': 'Could not generate invite link.',
    'employees.toast.invite_link_copied': 'Invite link copied for {name}.',
    'employees.toast.invite_link_copy_failed': 'Could not copy link. Try again.',
    'employees.toast.phone_required_for_invite':
      'Register a valid phone number before sending the invite.',
    'employees.toast.invite_generate_failed': 'Could not generate invite.',
    'employees.toast.invite_whatsapp_sent':
      'Invite sent via WhatsApp to {name} (valid for 30 min).',
    'employees.toast.invite_whatsapp_send_failed': 'Could not send invite via WhatsApp.',

    'clients.toast.cep_not_found': 'ZIP code not found.',
    'clients.toast.cep_fetch_error': 'Error fetching ZIP code. Try again.',
    'clients.toast.name_required': 'Enter the customer name.',
    'clients.toast.phone_invalid': 'Enter a valid phone number (at least 10 digits).',
    'clients.toast.save_error': 'Error saving customer.',
    'clients.toast.new_value_required': 'Enter the new value.',
    'clients.toast.no_valid_client_selected':
      'No customer selected with valid ID to update.',
    'clients.toast.bulk_update_success': '{count} customer(s) updated.',
    'clients.toast.bulk_update_partial_fail': '{count} record(s) could not be updated.',
    'clients.toast.bulk_update_error': 'Error in bulk update.',
    'clients.selected_count': '{count} selected',

    'order_confirmation.toast.pix_key_copied': 'PIX key copied!',
    'order_confirmation.toast.copy_failed': 'Could not copy. Select and copy manually.',
    'order_confirmation.toast.pix_data_copied': 'PIX details copied to share!',
    'order_confirmation.toast.share_failed': 'Could not share. Try copying the key.',

    'order_confirmation.title': 'Order Confirmed!',
    'order_confirmation.thanks': 'Thank you for your order!',
    'order_confirmation.pix_payment': 'PIX payment',
    'order_confirmation.pix_instructions_with_key':
      'Review the details below, copy the key or share everything in your bank app.',
    'order_confirmation.pix_instructions_no_key':
      'Your order was registered with PIX. Store details are not available on this screen — ask via WhatsApp or at the counter.',
    'order_confirmation.holder': 'Account holder:',
    'order_confirmation.bank': 'Bank:',
    'order_confirmation.type': 'Type:',
    'order_confirmation.pix_key': 'PIX key',
    'order_confirmation.copy_pix_aria': 'Copy PIX key',
    'order_confirmation.share_pix': 'Share PIX details',
    'order_confirmation.shared': 'Shared!',
    'order_confirmation.share_title': 'PIX details',
    'order_confirmation.preparing_message':
      'We are preparing your order with care and it will be ready soon.',
    'order_confirmation.preparing_badge': 'Your order is being prepared',
    'order_confirmation.track_order': 'Track Order',
    'order_confirmation.new_order': 'Place New Order',
    'order_confirmation.footer_hint': 'You can place a new order at any time',

    'entregas.status.in_progress': 'In progress',
    'entregas.status.done': 'Completed',
    'entregas.status.cancelled': 'Cancelled',
    'entregas.status.pending': 'Awaiting departure',
    'entregas.customer_fallback': 'Customer',
    'entregas.stop.delivered': 'Delivered',
    'entregas.stop.pending': 'Pending',
    'entregas.stop.order': 'Order',
    'entregas.stop.dispatch': 'Dispatch',
    'entregas.stop.delivery': 'Delivery',
    'entregas.stop.order_to_dispatch': 'Order → dispatch:',
    'entregas.stop.dispatch_to_delivery': 'Dispatch → delivery:',
    'entregas.route.departure': 'Departure {index}',
    'entregas.route.deliveries_count': '{count} delivery(ies)',
    'entregas.route.dispatch_at': 'Dispatch {time}',
    'entregas.route.started_at': ' · Departure {time}',
    'entregas.route.finished_at': ' · End {time}',
    'entregas.duration_min': '{min} min',
    'entregas.duration_h': '{h}h',
    'entregas.duration_h_min': '{h}h {m}min',
    'entregas.date_picker_title': 'Operational day (same rule as cash register)',
    'entregas.date_prev': 'More recent day',
    'entregas.date_next': 'Older day',
    'entregas.mode_work': 'Work mode',
    'entregas.mode_working': 'Working',
    'entregas.back_to_today': 'Back to today',
    'entregas.avg_min_prefix': '~{min} min',
    'entregas.mode_report': 'Report',
    'entregas.refresh': 'Refresh',
    'entregas.today_suffix': ' · today',
    'entregas.hint_work_mode': ' · current operational day (register window +2h after closing)',
    'entregas.hint_history': ' · personal delivery history',
    'entregas.summary.departures': 'Departure(s)',
    'entregas.summary.deliveries': 'Delivery(ies)',
    'entregas.summary.completed': 'Completed',
    'entregas.summary.avg_dispatch_delivery': 'Avg dispatch → delivery',
    'entregas.summary.fees': 'Fees today',
    'entregas.summary.daily': 'Day rate',
    'entregas.summary.fees_total': 'Fees + day rate',
    'entregas.page.title': 'My deliveries',
    'entregas.page.subtitle_active': 'Use the routes below to depart and mark deliveries',
    'entregas.page.subtitle_done_today': 'Today\'s departures completed — see summary below',
    'entregas.page.subtitle_waiting': 'Scan the ticket QR to add deliveries to your bag',
    'entregas.page.subtitle_report': 'Report for {date}',
    'entregas.empty.no_routes': 'No routes assigned at the moment.',
    'entregas.empty.no_deliveries_day': 'No deliveries recorded on {date}.',
    'entregas.empty.hint_work': 'Scan the dispatch ticket QR with your courier login. Add several orders, then start the run in the order you choose.',
    'entregas.empty.hint_history': 'Select another day in the shortcuts above or return to today.',
    'entregas.map_unavailable': 'Embedded map unavailable — use the list and open each address in Google Maps.',
    'entregas.open_maps': 'Open',
    'entregas.open_google_maps': 'Open in Google Maps',
    'entregas.delivery_progress': 'Delivery {current} of {total}',
    'entregas.start_departure': 'Start departure',
    'entregas.confirm_delivery': 'Confirm delivery',
    'entregas.confirm_ifood': 'Confirm + iFood code',
    'entregas.send_ifood_only': 'Send code to store only',
    'entregas.upcoming': 'Upcoming deliveries',
    'entregas.departure_running': ' · active',
    'entregas.completed_today': 'Departures completed today',

    'contract_plan.toast.invalid_cnpj':
      'If providing CNPJ, use 14 valid digits or leave blank.',
    'contract_pix.toast.nothing_to_copy': 'Nothing to copy ({label}).',
    'contract_pix.toast.copied': '{label} copied.',
    'contract_pix.toast.copy_failed': 'Could not copy. Select the text manually.',

    'entregas.toast.load_routes_error': 'Error loading routes',
    'entregas.toast.route_started': 'Route started. Safe delivery!',
    'entregas.toast.route_completed': 'Route completed!',
    'entregas.toast.start_route_error': 'Error starting route',
    'entregas.toast.delivery_confirmed': 'Delivery confirmed!',
    'entregas.toast.delivery_ifood_sent': 'Delivery and iFood code sent!',
    'entregas.toast.confirm_error': 'Error confirming',
    'entregas.toast.code_sent': 'Code sent to store',
    'entregas.toast.send_code_error': 'Error sending code',
    'entregas.bag.reorder_hint': '{count} delivery(ies) — drag to set 1st, 2nd…',
    'entregas.pay.paid': 'Already paid — do not charge',
    'entregas.pay.charge': 'Collect on delivery',
    'entregas.pay.charge_amount': 'Collect {amount}',
    'entregas.toast.reorder_error': 'Could not save the order',
    'despacho.title': 'Claim order',
    'despacho.missing_token': 'Invalid QR. Print a new dispatch ticket.',
    'despacho.need_courier': 'Sign in with the courier account to claim this order.',
    'despacho.load_error': 'Could not read this QR.',
    'despacho.claim': 'Take this delivery',
    'despacho.already_mine': 'This order is already yours.',
    'despacho.open_app': 'Open my deliveries',
    'despacho.transfer_title': 'Switch courier?',
    'despacho.transfer_msg': 'This delivery is with {name}. Take it over?',
    'despacho.transfer_confirm': 'Yes, take it',
    'despacho.claimed': 'Order added to your bag.',
    'despacho.scan_next': 'Scan the next QR to add more deliveries, or open the route to set the order and start.',
    'despacho.go_bag': 'Set order and start',
    'despacho.bag_count': '{count} delivery(ies) in the bag',
    'despacho.neighborhood': 'Neighborhood',
    'despacho.payment': 'Payment',

    'dev.toast.invalid_cpf': 'Invalid CPF. Enter 11 digits or leave blank.',
    'dev.toast.invalid_cpf_fix': 'Invalid CPF. Fix the number or leave blank.',
    'dev.toast.name_required': 'Enter full name.',
    'dev.toast.phone_required_whatsapp':
      'Enter phone with area code to send WhatsApp invite.',
    'dev.toast.registration_sent': 'Registration for "{name}" submitted.',
    'dev.toast.registered_whatsapp':
      '"{name}" registered. Invite sent via WhatsApp (30 min).',
    'dev.toast.registered_success': '"{name}" registered successfully.',
    'dev.toast.invalid_collaborator_id':
      'Invalid CPF or employee id to save permissions.',
    'dev.toast.permissions_updated': 'Permissions updated successfully. {hint}',
  },
  es: {
    'public_orders.toast.cep_not_found': 'Código postal no encontrado',
    'public_orders.toast.max_addons': 'Límite máximo de {max} adicional(es) para {category}',
    'public_orders.toast.addons_min_in_item':
      'En el ítem "{item}", debe elegir al menos {min} ítem(s) de "{category}"',

    'orders.toast.max_flavors': 'Máximo de {max} sabor(es) para este tipo',
    'orders.toast.max_addons': 'Límite máximo de {max} adicional(es) para {category}',
    'orders.toast.invalid_deadline_range':
      'Ingrese valores válidos (el mínimo debe ser menor o igual al máximo)',
    'orders.toast.save_deadline_error': 'Error al guardar plazo',
    'orders.toast.delete_deadline_success': 'Plazo eliminado con éxito',
    'orders.toast.delete_deadline_error': 'Error al eliminar plazo',
    'orders.toast.update_deadline_success': 'Plazo de entrega actualizado con éxito',
    'orders.toast.update_deadline_error': 'Error al actualizar plazo seleccionado',
    'orders.toast.select_product_size': 'Seleccione el tamaño/tipo del producto',
    'orders.toast.select_flavors_count': 'Seleccione {count} sabor(es) para este tipo',
    'orders.toast.addons_min_for_product':
      'Debe elegir al menos {min} ítem(s) de "{category}" para este producto',
    'orders.toast.print_request_failed':
      'Error al procesar solicitud de impresión tras múltiples intentos',
    'orders.toast.print_order_failed': 'No se pudo imprimir el pedido #{order}.',

    'internal_order.toast.item_updated': '¡Ítem actualizado en el carrito!',
    'internal_order.toast.item_added': '¡Producto agregado al carrito!',
    'internal_order.toast.max_flavors': 'Máximo de {max} sabor(es) para este tipo',
    'internal_order.toast.max_addons': 'Límite máximo de {max} adicional(es) para {category}',
    'internal_order.toast.order_parsed_review':
      'Pedido interpretado — revise y finalice en el checkout',
    'internal_order.toast.customer_data_applied': 'Datos del cliente aplicados al pedido',
    'internal_order.toast.ifood_applied_review':
      'Pedido iFood aplicado — revise y finalice en el checkout',
    'internal_order.toast.no_ai_items_suggestion':
      'Ninguna sugerencia de ítems para aplicar al carrito.',
    'internal_order.toast.no_valid_ai_items':
      'Ningún ítem válido encontrado en la sugerencia de la IA.',
    'internal_order.toast.ai_items_added':
      'Ítems sugeridos por la IA agregados al carrito. Revise valores y tarifas normalmente.',
    'internal_order.toast.order_parsed_review_menu':
      'Pedido interpretado — revise menú, carrito y finalice',
    'internal_order.toast.customer_data_select_products':
      'Datos del cliente aplicados — elija productos en el menú',
    'internal_order.toast.question_sent': 'Pregunta enviada — esperando respuesta del cliente',

    'company.toast.image_upload_success': 'Imagen enviada con éxito.',
    'company.toast.image_upload_error': 'Error al subir imagen.',
    'company.toast.logo_saved': 'Logotipo guardado con éxito.',
    'company.toast.logo_save_error': 'Error al guardar logotipo.',
    'company.toast.logo_removed': 'Logotipo eliminado con éxito.',
    'company.toast.logo_remove_error': 'Error al eliminar logotipo.',
    'company.toast.logo_process_error': 'Error al procesar logotipo.',
    'company.toast.save_generic_error': 'Error al guardar: {error}',
    'company.toast.move_bairro_failed_refresh':
      'No se pudo mover el barrio. Actualice la página e intente de nuevo.',
    'company.toast.move_bairro_name_required':
      'Complete el nombre del barrio antes de moverlo a otra tarifa.',
    'company.toast.move_bairro_already_exists': 'Este barrio ya existe en esta tarifa.',
    'company.toast.move_bairro_failed': 'No se pudo mover el barrio.',
    'company.toast.fee_added_success': '¡Tarifa de ${amount} agregada con éxito!',
    'company.toast.menu_category_created': '¡Categoría "{name}" creada con éxito!',

    'menu_display.loading': 'Cargando menú...',
    'menu_display.no_products': 'Ningún producto encontrado en el menú',
    'menu_display.title.delete_image': 'Eliminar imagen',
    'menu_display.title.delete_product': 'Eliminar producto',
    'menu_display.title.edit_category': 'Editar categoría y tipos de precio',
    'menu_display.title.delete_category': 'Eliminar categoría y todos los productos',
    'menu_display.zero_price.item': 'Este artículo está con precio cero. Puede seguir activo.',
    'menu_display.zero_price.category': 'Hay artículos con precio cero en esta categoría.',
    'menu_display.zero_price.ignore_item': 'Ignorar este artículo',
    'menu_display.zero_price.ignore_category': 'Ignorar la categoría',
    'menu_display.toast.image_upload_success': 'Imagen enviada con éxito.',
    'menu_display.toast.image_upload_error': 'Error al enviar imagen: {error}',
    'menu_display.toast.image_delete_success': 'Imagen eliminada con éxito.',
    'menu_display.toast.image_delete_error': 'Error al eliminar imagen: {error}',

    'employees.toast.password_already_set':
      'Este colaborador ya creó la contraseña — pídale que inicie sesión.',
    'employees.toast.invite_link_generate_failed': 'No se pudo generar el enlace de invitación.',
    'employees.toast.invite_link_copied': 'Enlace de invitación copiado para {name}.',
    'employees.toast.invite_link_copy_failed': 'No se pudo copiar el enlace. Intente de nuevo.',
    'employees.toast.phone_required_for_invite':
      'Registre un teléfono válido antes de enviar la invitación.',
    'employees.toast.invite_generate_failed': 'No se pudo generar la invitación.',
    'employees.toast.invite_whatsapp_sent':
      'Invitación enviada por WhatsApp a {name} (válida por 30 min).',
    'employees.toast.invite_whatsapp_send_failed':
      'No se pudo enviar la invitación por WhatsApp.',

    'clients.toast.cep_not_found': 'Código postal no encontrado.',
    'clients.toast.cep_fetch_error': 'Error al buscar código postal. Intente de nuevo.',
    'clients.toast.name_required': 'Ingrese el nombre del cliente.',
    'clients.toast.phone_invalid': 'Ingrese un teléfono válido (mínimo 10 dígitos).',
    'clients.toast.save_error': 'Error al guardar cliente.',
    'clients.toast.new_value_required': 'Ingrese el nuevo valor.',
    'clients.toast.no_valid_client_selected':
      'Ningún cliente seleccionado con ID válido para actualizar.',
    'clients.toast.bulk_update_success': '{count} cliente(s) actualizado(s).',
    'clients.toast.bulk_update_partial_fail': '{count} registro(s) no pudieron actualizarse.',
    'clients.toast.bulk_update_error': 'Error en la actualización masiva.',
    'clients.selected_count': '{count} seleccionado(s)',

    'order_confirmation.toast.pix_key_copied': '¡Clave PIX copiada!',
    'order_confirmation.toast.copy_failed':
      'No se pudo copiar. Seleccione y copie manualmente.',
    'order_confirmation.toast.pix_data_copied': '¡Datos PIX copiados para compartir!',
    'order_confirmation.toast.share_failed':
      'No se pudo compartir. Intente copiar la clave.',

    'order_confirmation.title': '¡Pedido confirmado!',
    'order_confirmation.thanks': '¡Gracias por su pedido!',
    'order_confirmation.pix_payment': 'Pago vía PIX',
    'order_confirmation.pix_instructions_with_key':
      'Revise los datos abajo, copie la clave o comparta todo en la app de su banco.',
    'order_confirmation.pix_instructions_no_key':
      'Su pedido fue registrado con PIX. Los datos de la tienda no están disponibles en esta pantalla — pida por WhatsApp o en el mostrador.',
    'order_confirmation.holder': 'Titular:',
    'order_confirmation.bank': 'Banco:',
    'order_confirmation.type': 'Tipo:',
    'order_confirmation.pix_key': 'Clave PIX',
    'order_confirmation.copy_pix_aria': 'Copiar clave PIX',
    'order_confirmation.share_pix': 'Compartir datos PIX',
    'order_confirmation.shared': '¡Compartido!',
    'order_confirmation.share_title': 'Datos PIX',
    'order_confirmation.preparing_message':
      'Estamos preparando su pedido con mucho cariño y estará listo pronto.',
    'order_confirmation.preparing_badge': 'Su pedido está siendo preparado',
    'order_confirmation.track_order': 'Rastrear pedido',
    'order_confirmation.new_order': 'Hacer nuevo pedido',
    'order_confirmation.footer_hint': 'Puede hacer un nuevo pedido en cualquier momento',

    'entregas.status.in_progress': 'En curso',
    'entregas.status.done': 'Completada',
    'entregas.status.cancelled': 'Cancelada',
    'entregas.status.pending': 'Esperando salida',
    'entregas.customer_fallback': 'Cliente',
    'entregas.stop.delivered': 'Entregado',
    'entregas.stop.pending': 'Pendiente',
    'entregas.stop.order': 'Pedido',
    'entregas.stop.dispatch': 'Despacho',
    'entregas.stop.delivery': 'Entrega',
    'entregas.stop.order_to_dispatch': 'Pedido → despacho:',
    'entregas.stop.dispatch_to_delivery': 'Despacho → entrega:',
    'entregas.route.departure': 'Salida {index}',
    'entregas.route.deliveries_count': '{count} entrega(s)',
    'entregas.route.dispatch_at': 'Despacho {time}',
    'entregas.route.started_at': ' · Salida {time}',
    'entregas.route.finished_at': ' · Fin {time}',
    'entregas.duration_min': '{min} min',
    'entregas.duration_h': '{h}h',
    'entregas.duration_h_min': '{h}h {m}min',
    'entregas.date_picker_title': 'Día operacional (misma regla de la caja)',
    'entregas.date_prev': 'Día más reciente',
    'entregas.date_next': 'Día más antiguo',
    'entregas.mode_work': 'Modo trabajo',
    'entregas.mode_working': 'Trabajando',
    'entregas.back_to_today': 'Volver al día actual',
    'entregas.avg_min_prefix': '~{min} min',
    'entregas.mode_report': 'Informe',
    'entregas.refresh': 'Actualizar',
    'entregas.today_suffix': ' · hoy',
    'entregas.hint_work_mode': ' · día operacional actual (ventana de caja +2h tras cerrar)',
    'entregas.hint_history': ' · historial personal de entregas',
    'entregas.summary.departures': 'Salida(s)',
    'entregas.summary.deliveries': 'Entrega(s)',
    'entregas.summary.completed': 'Completada(s)',
    'entregas.summary.avg_dispatch_delivery': 'Promedio despacho → entrega',
    'entregas.summary.fees': 'Tarifas del día',
    'entregas.summary.daily': 'Diaria',
    'entregas.summary.fees_total': 'Tarifas + diaria',
    'entregas.page.title': 'Mis entregas',
    'entregas.page.subtitle_active': 'Use las rutas abajo para salir y dar de baja las entregas',
    'entregas.page.subtitle_done_today': 'Salidas de hoy completadas — vea el resumen abajo',
    'entregas.page.subtitle_waiting': 'Lea el QR del cupón para juntar las entregas',
    'entregas.page.subtitle_report': 'Informe de {date}',
    'entregas.empty.no_routes': 'Ninguna ruta asignada en este momento.',
    'entregas.empty.no_deliveries_day': 'Ninguna entrega registrada en {date}.',
    'entregas.empty.hint_work': 'Lea el QR del cupón de despacho con su usuario. Junte varias comandas y luego inicie la salida en el orden que quiera.',
    'entregas.empty.hint_history': 'Seleccione otro día en los accesos arriba o vuelva al día actual.',
    'entregas.map_unavailable': 'Mapa integrado no disponible — use la lista y abra cada dirección en Google Maps.',
    'entregas.open_maps': 'Abrir',
    'entregas.open_google_maps': 'Abrir en Google Maps',
    'entregas.delivery_progress': 'Entrega {current} de {total}',
    'entregas.start_departure': 'Iniciar salida',
    'entregas.confirm_delivery': 'Confirmar entrega',
    'entregas.confirm_ifood': 'Confirmar + código iFood',
    'entregas.send_ifood_only': 'Solo enviar código a la tienda',
    'entregas.upcoming': 'Próximas entregas',
    'entregas.departure_running': ' · en curso',
    'entregas.completed_today': 'Salidas completadas hoy',

    'contract_plan.toast.invalid_cnpj':
      'Si informa CNPJ, use 14 dígitos válidos o déjelo en blanco.',
    'contract_pix.toast.nothing_to_copy': 'Nada para copiar ({label}).',
    'contract_pix.toast.copied': '{label} copiado.',
    'contract_pix.toast.copy_failed':
      'No se pudo copiar. Seleccione el texto manualmente.',

    'entregas.toast.load_routes_error': 'Error al cargar rutas',
    'entregas.toast.route_started': 'Ruta iniciada. ¡Buena entrega!',
    'entregas.toast.route_completed': '¡Ruta completada!',
    'entregas.toast.start_route_error': 'Error al iniciar ruta',
    'entregas.toast.delivery_confirmed': '¡Entrega confirmada!',
    'entregas.toast.delivery_ifood_sent': '¡Entrega y código iFood enviados!',
    'entregas.toast.confirm_error': 'Error al confirmar',
    'entregas.toast.code_sent': 'Código enviado a la tienda',
    'entregas.toast.send_code_error': 'Error al enviar código',
    'entregas.bag.reorder_hint': '{count} entrega(s) — arrastre para definir la 1.ª, 2.ª…',
    'entregas.pay.paid': 'Ya pagado — no cobrar',
    'entregas.pay.charge': 'Cobrar en la entrega',
    'entregas.pay.charge_amount': 'Cobrar {amount}',
    'entregas.toast.reorder_error': 'No se pudo guardar el orden',
    'despacho.title': 'Tomar comanda',
    'despacho.missing_token': 'QR inválido. Pida un cupón de despacho nuevo.',
    'despacho.need_courier': 'Entre con el usuario del motoboy para tomar esta comanda.',
    'despacho.load_error': 'No se pudo leer este QR.',
    'despacho.claim': 'Tomar esta entrega',
    'despacho.already_mine': 'Esta comanda ya está con usted.',
    'despacho.open_app': 'Abrir mis entregas',
    'despacho.transfer_title': '¿Cambiar motoboy?',
    'despacho.transfer_msg': 'Esta entrega está con {name}. ¿Quiere tomarla?',
    'despacho.transfer_confirm': 'Sí, tomarla',
    'despacho.claimed': 'Comanda en su bolsa.',
    'despacho.scan_next': 'Lea el siguiente QR para juntar más entregas, o abra la ruta para definir el orden y salir.',
    'despacho.go_bag': 'Definir orden y salir',
    'despacho.bag_count': '{count} entrega(s) en la bolsa',
    'despacho.neighborhood': 'Barrio',
    'despacho.payment': 'Pago',

    'dev.toast.invalid_cpf': 'CPF inválido. Ingrese 11 dígitos o déjelo en blanco.',
    'dev.toast.invalid_cpf_fix': 'CPF inválido. Corrija el número o déjelo en blanco.',
    'dev.toast.name_required': 'Ingrese el nombre completo.',
    'dev.toast.phone_required_whatsapp':
      'Ingrese el teléfono con DDD para enviar la invitación por WhatsApp.',
    'dev.toast.registration_sent': 'Registro de "{name}" enviado.',
    'dev.toast.registered_whatsapp':
      '"{name}" registrado(a). Invitación enviada por WhatsApp (30 min).',
    'dev.toast.registered_success': '"{name}" registrado(a) con éxito.',
    'dev.toast.invalid_collaborator_id':
      'CPF o id del colaborador inválido para guardar permisos.',
    'dev.toast.permissions_updated': 'Permisos actualizados con éxito. {hint}',
  },
} as const;
